module.exports = __webpack_public_path__ + "static/loviatar-symbol-DND3_FnP-8432ece46981548c7ca1f41c232654c7.webp";